define('cols',[
	  'backbone'
	, 'even'
	, 'part'
], function (Backbone, Even, Part) {

	/*
	 * La 'main-collection' para la captura de todo el contenido
	 * y asignamiento a la correspondiente vista.
	**/
	return Backbone.Collection.extend({

		/*
		 * Objeto que maneja la información acerca de los 'frame-views'.
		**/
		partSite: {
			  main_head: '#main_head' 
			, main_navi: '#main_navi' 
			, main_link: '#main_link' 
			, main_nets: '#main_nets' 
			, main_cell: '#main_cell' 
			, main_line: '#main_line' 
			, main_info: '#main_info' 
		},

		partPage: {
			  main_page: '#main_page' 
		},

		/*
		 * Objeto que maneja los selectores de las plantilla
		 * para cada contenido principal (loop, single, page and error).
		**/
		// mainTmpl: {
		// 	  loop: { 'tmpl': $('#loop-tmpl').html() }
		// 	, error: { 'tmpl': $('#error-tmpl').html() }
		// 	, single: { 'tmpl': $('#single-tmpl').html() }
		// 	, page: { 'tmpl': $('#page-tmpl').html() }
		// 	, page_default: { 'tmpl': $('#page_default-tmpl').html() }
		// 	, page_inicio: { 'tmpl': $('#page_inicio-tmpl').html() }
		// },

		/*
		 * Insertando los 'frame-views' como footer, header, etc. y
		 * enlazandolos a las 'assignViews-method' a el 'add-event' de
		 * la colección.
		**/
		initialize : function initialize() {

			// console.log('... Definiendo templates/callbacks');
			// this.defineTemplates();
			this.on('add', this.assignViews, this);
			// console.log('initialize');
		},

		/*
		 * Capturando todos los métodos a manejar en este gran potoposte de 
		 * datos cargados del 'cms-system'.
		**/
		assignViews : function assignView(model, obj, resp) {
			//-- 
			var data = '';
			var type = '';

			// console.info('model');
			// console.log(model);
			// console.info('obj');
			// console.log(obj);
			// console.info('resp');
			// console.log(resp);

			// if(resp && resp.xhr){
			if(resp){
				//-- 
				// data = 
				// 	(resp.xhr.status === 500 || resp.xhr.status === 401 || resp.xhr.status === 401) 
				// 	? 
				// 	(this.at(0))
				// 	: 
				// 	(this.at(0));
				data = 
					(resp.xhr.status === 500 || resp.xhr.status === 301 || resp.xhr.status === 401 || resp.xhr.status === 401) 
					? 
					resp.xhr.responseJSON 
					: 
					resp.xhr.responseJSON;

				// console.log('data: ');
				// console.log(data);

				if(resp.xhr.status == 301)
				{
					// console.log('data.redirect: '+data.redirect);
					window.rtr.navigate(data.path, { trigger: true })
					return;
				}

				if(data && data.type){
					//-- 
					// type = 
					// 	(resp.status === 404 || resp.status === 401) 
					// 	? resp.xhr.responseJSON.type 
					// 	: data.get('type');
					type = data.type;
				}
			}

			// console.log('... AssignViews Data: '+data);
			// console.log(data);
			// console.log('... AssignViews Type: '+type);
			// console.log(type);

			// return false;
			// if(type!='error'){
			// 	this
			// 	.insertPart(data)
			// }

			this
			.insertPart(data)
			.applyMainView(data)
			.removeCurrentClass(type)
			// .handlePageLinks(data)
			// .handleComments(data)
			// .handleCommentForm(data);
		},

		/*
		 * Insertando los 'frame-views'.
		**/
		insertPart : function insertPartView(data) {
			// console.info('Insertando parts');
			// console.dir(data);

			// tmpl = 'main_line';

			for ( part in this.partSite ) {
				// var tmpl = data.get('tmpl');
				//-- 
				this.insertPartView(data, part);
			}

			return this;
		},

		/*
		 * Insertando los 'frame-views'.
		**/
		insertPartView : function insertPartView(data, tmpl) {
			// console.info('Insertando part');
			// console.dir(data);

			// var data      = data.get('part');
			var data      = data.part;
			var tmpl      = tmpl+'';
			var tmpl_file = tmpl;

			// console.log('... Insertando view: '+tmpl+'->'+this.partSite[tmpl]);
			require(['hbs!./../../../resources/views/hbs/hbs_partials/_'+tmpl_file], function ( tmpl_hbrs ) {
				//-- 
				(new Part[tmpl]({ 
					  el : '#'+tmpl
					, view: tmpl_hbrs
					, data: data 
				}));
			});
		},

		// /*
		//  * Insertando los 'eventos'.
		// **/
		// defineTemplates : function defineTemplates() {

		// 	// for ( template in this.mainTmpl ) {
		// 	for ( template in Tmpl ) {
		// 		// console.info('defineTemplates: Template ' + template); 
		// 		// console.log('template ' + template);
		// 		// console.info('defineTemplates: Defining Function' + Site[template]); 
		// 		// console.log('Template: '+template);
		// 		// console.log('Template: '+template.replace('.hbs', ''));
		// 		var tmpl_func = template.replace('.hbs', '');
		// 		this.mainTmpl[template]      = {};
		// 		this.mainTmpl[template].func = Site[tmpl_func] === undefined ? function(){ console.log('template: '+template); } : Site[tmpl_func];
		// 		// this.mainTmpl[template].tmpl = Tmpl[template];
		// 		//-- 
		// 		require(['hbs!./../../../resources/views/hbs/'+tmpl_func], function ( tmpl ) {
		// 			// var tmpl = tmpl({adjective: "favorite"});
		// 			// document.body.innerHTML = tmpl({adjective: "favorite"});
		// 			console.log('Tmpl: '+ tmpl_func);
		// 			this.mainTmpl[template].tmpl = tmpl;
		// 		});

		// 		// template.func(Site[tmpl_func]);
		// 	}
		// 	// console.log(this.mainTmpl);
		// },

		/*
		 * Insertando el contenido principal: Muchos registros o
		 * una página estática.
		**/
		applyMainView: function applyMainView(data) {
			// console.log(data);
			// var type      = data.get('type');
			// var tmpl      = 'main_page';
			// var tmpl_file = data.get('tmpl');
			// var meta      = data.get('meta');
			// var page      = data.get('page');
			// var partPage  = this.partPage;
			var type      = data.type;
			var tmpl      = 'main_page';
			var tmpl_file = data.tmpl;
			var meta      = data.meta;
			var page      = data.page;
			var partPage  = this.partPage;


			// console.info('... Type: '+data);
			// console.info(data);
			// console.info('... Page: '+page);
			// console.info(page);
			// console.info('... tmpl: '+tmpl);
			// console.info(type);
			// console.info('... meta: '+meta);
			// console.info(meta);

			// return this;
			// console.log(meta);

			try {
				if(meta){
					// document.getElementsByTagName('title')[0].innerHTML       = meta.title;
					document.getElementsByTagName('title')[0].innerHTML       = meta.title_navi;
					$('meta[name=og\\:url]').attr('content', meta.title);
					$('meta[name=twitter\\:url]').attr('content', meta.title);
					// document.getElementsByTagName('description')[0].innerHTML = meta.Description;
					// document.getElementsByTagName('keywords')[0].innerHTML    = meta.Keywords;
				}

				//-- 
				require(['hbs!./../../../resources/views/hbs/'+tmpl_file], function ( view ) {
					// console.log('Tmpl: '+ tmpl_file);
					//-- Part
					(new Part[tmpl]({ 
						  el : '#'+tmpl
						// , view: this.mainTmpl[template].tmpl = tmpl;
						, view: view
						, data : { 'type': type, 'page': page }
						// , data : page
					}))
					.render(
						function(){
							//-- Cerrando Overlay
							$.fancybox.helpers.overlay.close();
							$.fancybox.hideLoading();
							//-- Llamando a callback de la página cargada
							// Site[tmpl_file] === undefined ? function(){ console.log('Calback para: '+tmpl_file+' no definido'); }() : Site[tmpl_file]()

							//--
							var path = requirejs.s.contexts._.config.baseUrl+'site/page/';
							var page = $('.page_base').attr('data-page');
							var page = type;
							var base = 'base';
							//--
							require
							([
								// path + 'pag_' + base + '.js',
								// path + 'pag_' + page + '.js'
								// '../jsc/site/page/pag_'+base,
								base,
								// '../jsc/site/page/pag_'+page,
								page
							],
							function ( Base, Page )
							{
								//--
								// console.log('Cargando... : '+base);
								//--
								Base.init();
								//--
								// console.log('Cargando... : '+page);
								//--
								Page.init();
							});

						}
					);
					// .render(this.mainTmpl[tmpl].func || (function(){}) );
				});
				// title = data.get('main_content').seo.title;
			}
			catch ( Exception ) { 
				console.log('Hay un problema obteniendo la plantilla para: ' + tmpl_file + Exception);
			};
			// document.title = title;

			return this;
		},

		/*
		 * Emitiendo evento para manejar el indicador de la navegación.
		**/
		removeCurrentClass: function removeCurrentClass(type) {
			// console.log('removeCurrentClass('+type+')');
			Even.trigger('UI.handleCurrentClass', type);
			return this;
		},

		/*
		 * Checando si una paginación es necesaria. Insertando la correspondiente
		 * vista o emitiendo evetno para remover la paginación actual.
		**/
		handlePageLinks: function handlePageLinks(data) {
			var pagelinks = data.get('pagelinks');
			if ( !pagelinks ) {
				Even.trigger('UI.removePageLinks');
				return this;
			}
			new Part.PageLinks({ el : '#page-links', content : pagelinks });
			return this;
		},

		/*
		 * Checando si lo cargado tiene sub registros. Insertandolos o
		 * removiendolos en la vista existente si los datos contienen 0 registros.
		**/
		handleComments: function handleComments(data) {
			var comments = data.get('comments');
			if ( !comments || !comments.length ) {
				Even.trigger('UI.removeComments');
				return this;
			}
			new Part.Comments({ el : '#comments-list', content : comments });
			return this;
		},

		/*
		 * Insertando la vista de comentarios, si es necesaria. Caso contrario removiendo
		 * el formulario de la vista existente.
		**/
		handleCommentForm: function handleCommentForm(data) {
			var commentform = data.get('commentform');
			if ( !commentform ) {
				Even.trigger('UI.removeCommentForm');
				return this;
			}
			new Part.CommentForm({ el : '#comment-form', content : commentform });
			return this;
		},

		/*
		 * Convirtiendo el mensaje de error de 404 y retornandolo 
		 * dentro de una función getter, así no quiebra el flujo. Follow the flow, yo.
		**/
		_handleErrorContent: function _handleErrorContent(resp) {
			console.log(resp);
 			// if(resp.xhr.status === 404 || resp.xhr.status === 401)
 			// {
 			// 	return 
 			// }
			return {}
			// console.log($.parseJSON(resp));
			// return {
			// 	get: function get(type) { return /^(content)$/.test(type) && $.parseJSON(resp).content; }
			// };
			// return {
			// 	get: function get(type) { return /^(exception_message)$/.test(type) && $.parseJSON(resp).exception_message; }
			// };
		}

	});

});
